// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__OLyHL","row":"styles_row__1rQWc"};